module.exports = __webpack_public_path__ + "img/9788901068695.74a5edb7.jpg";